import {useState, React} from "react";
import "./App.css";

import { MyContext } from "./MyContext";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Custom.scss";
import "bootstrap/dist/css/bootstrap.css";

import Navbar from "./Components/Navbar";
// import BigImage from "./Components/InternalPages/BigImage";
import Footer from "./Components/Footer";
import PrivacyPolicy from "./Components/InternalPages/PrivacyPolicy";
import Contactus from "./Components/Contactus";
import Term from "./Components/Term";
import AboutSection from "./Components/InternalPages/AboutSection";
import Deleteaccount from "./Components/InternalPages/Deleteaccount";
import BlogSection from "./Components/BlogSection";
import Article from "./Components/InternalPages/Article";
import EnterpriseLogin from "./EnterpriseLogin";
import DriverPartnerLogin from "./DriverPartnerLogin";
import { TbSection } from "react-icons/tb";
import Home from './Home';
// import big from "../assets/Banner.webp";


function App() {

  const [selectedCity, setSelectedCity] = useState("Ahmedabad");

  return (
<MyContext.Provider value={{ 
  selectedCity, 
  setSelectedCity 
  }}>
    <Router>
    <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contact-us" element={<Contactus />} />
        <Route path="/term-condition" element={<Term />} />
        <Route path="/about-us" element={<AboutSection />} />
        <Route path="/delete-account" element={<Deleteaccount />} />
        <Route path="/blog-section" element={<BlogSection />} />
        <Route path="/blog/:post_slug" element={<Article />} />
        {/* <Route path="/author/:post_slug" element={<Author />} /> */}
        <Route path="/enterprise-login" element={<EnterpriseLogin />} />
        <Route path="/driver-partner-login" element={<DriverPartnerLogin />} />
      </Routes>
      <Footer />

    </Router>
    </MyContext.Provider>
  );
}

export default App;
